import ApiPermisos from './../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    errorMsj: '',
    setmoney_months: [],
    setdatas: [],
    setdataTurns: [],
    setdaysWorkedInTheMonths: [],
    loading: false,
   
  },
  getters: {},
  mutations: {
    setmoney_month: (state, setmoney_months) => {
       state.setmoney_months = setmoney_months;
    },
    setdata: (state, setdatas) => {
       state.setdatas = setdatas;
    },
    setdataTurn: (state, setdataTurns) => {
       state.setdataTurns = setdataTurns;
    },
    setdaysWorkedInTheMonth: (state, setdaysWorkedInTheMonths) => {
       state.setdaysWorkedInTheMonths = setdaysWorkedInTheMonths;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
  },
  actions: {    
    //Trae la informacion de las categorias del derecho de petición
    actGetTipsEmployee: async ({
      commit
    },data) => {
        commit('setLoading', true);
        let response = await ApiPermisos.TipsEmployee(data);
        //console.log('mes',response.data)
        if (response.error) {
            return response.error;
        }
        else{
          commit('setLoading', false);
          commit('setmoney_month', response.money_month);
          commit('setdata', response.data);
          commit('setdataTurn', response.dataTurn);
          commit('setdaysWorkedInTheMonth', response.daysWorkedInTheMonth);
        }
        return true;
    },
    

    }
}

